/**
 * Zentrale Site-Config — kanonische Domain, Kontakt-Adresse, Marken-Meta.
 *
 * WICHTIG: Diese Werte werden für SEO (Canonical, Open-Graph, Structured Data,
 * Sitemap-Absolut-URLs) verwendet — sie MÜSSEN mit der DNS-/Deployment-
 * Realität übereinstimmen. Beim Domain-Wechsel: hier zentral anpassen,
 * dann greift die Änderung überall (Home, Sylt, Erleben, Project, robots.txt,
 * sitemap.xml).
 */
export const SITE_ORIGIN = "https://www.hypefly.de";
export const SITE_HOST = "www.hypefly.de";

/** Kanonische URL für einen relativen Pfad. */
export function canonical(path: string): string {
    const p = path.startsWith("/") ? path : `/${path}`;
    return `${SITE_ORIGIN}${p}`;
}

/** Absolute URL für Media-/OG-Bilder — externe URLs (http/https) unverändert. */
export function absoluteAsset(url: string): string {
    if (!url) return `${SITE_ORIGIN}/`;
    if (/^https?:\/\//i.test(url)) return url;
    return `${SITE_ORIGIN}${url.startsWith("/") ? "" : "/"}${url}`;
}
